import { render, staticRenderFns } from "./certificateList.vue?vue&type=template&id=7ed85254&"
import script from "./certificateList.vue?vue&type=script&lang=js&"
export * from "./certificateList.vue?vue&type=script&lang=js&"
import style0 from "./certificateList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports